import { OfficeDialogMessageType } from "@/common/enums";
import {
  deleteSelectResourceDialog,
  selectResourceDialog,
} from "@/redux/slices/resources/ResourceSlice";
import { IMessageFromDialog, ResourceInfo } from "@/services";
import DrawFloorPlan from "@/view/addin/resource-list/floor-plan/draw-floor-plan";
import { Dispatch } from "@reduxjs/toolkit";
import { connect } from "react-redux";

const mapDispatchToProps = (
  dispatch: Dispatch<any>,
  ownProps: { messageToParent?: (messageObject: IMessageFromDialog) => void }
) => {
  return {
    selectResource: (resource: ResourceInfo) => {
      if(ownProps?.messageToParent) {
        ownProps?.messageToParent({MessageType: OfficeDialogMessageType.ResourceSelected, data: resource?.toJson()})
      }
      dispatch(selectResourceDialog(resource));
    },
    deleteSelectResource: (resource: ResourceInfo) => {
      if(ownProps?.messageToParent) {
        ownProps?.messageToParent({MessageType: OfficeDialogMessageType.DeResourceSelected, data: resource?.toJson()})
      }
      dispatch(deleteSelectResourceDialog(resource));
    },
  };
};

export default connect(null, mapDispatchToProps)(DrawFloorPlan);
